// Keep Volt's preview placement/lifecycle; adapt only this campaign's product action.
const section = document.querySelector("[id$='__shop_the_look_p4']");
const modal = document.getElementById('quick-add-dialog');
const productLinkTemplate = document.getElementById('QuickAddProductLink');

if (section && modal && productLinkTemplate) {
  section.querySelectorAll('volt-product-hotspot-preview').forEach((hotspot) => {
    const link = hotspot.querySelector('.hotspot-dialog__link');
    if (!link?.href) return;

    const quickAdd = document.createElement('quick-add-component');
    quickAdd.dataset.productUrl = link.href;
    quickAdd.dataset.productTitle = hotspot.dataset.productTitle || '';
    link.replaceWith(quickAdd);
    quickAdd.append(link);

    const cue = document.createElement('span');
    cue.className = 'hotspot-dialog__product-action';
    cue.setAttribute('aria-hidden', 'true');
    const icon = productLinkTemplate.content.querySelector('svg')?.cloneNode(true);
    if (icon) cue.append(icon);
    cue.append('SEE PRODUCT');
    hotspot.querySelector('.hotspot-dialog__product-info')?.append(cue);
    link.setAttribute('aria-label', `See product: ${hotspot.dataset.productTitle || ''}`);

    const openQuickBuy = (event) => {
      if (typeof quickAdd.handleClick !== 'function') return;
      modal.addEventListener('dialog:close', () => {
        hotspot.querySelector('.hotspot-trigger')?.focus({ preventScroll: true });
      }, { once: true });
      quickAdd.handleClick(event);
    };

    link.addEventListener('click', openQuickBuy);

    // Fine-pointer users see the preview on hover; the + itself buys directly.
    // Coarse-pointer users keep the two-tap preview flow where hover is absent.
    hotspot.querySelector('.hotspot-trigger')?.addEventListener('click', (event) => {
      if (!window.matchMedia('(min-width: 750px) and (hover: hover) and (pointer: fine)').matches) return;
      if (typeof quickAdd.handleClick !== 'function') return;
      event.stopImmediatePropagation();
      if (!hotspot.querySelector('.hotspot-dialog')?.open) hotspot.open();
      openQuickBuy(event);
    }, { capture: true });
  });
}
